import './accordion.scss';
import "accordion-js/dist/accordion.min.css";
import Accordion from "accordion-js";

const accordions = Array.from(document.querySelectorAll(".accordion-container"));

if (accordions.length) {
    new Accordion(accordions, {});
}
